export const COMING_SOON_PACK_ID = 'calm-health-coming-soon';
export const MINDSHIFT_PACK_ID = 'calm-health-mindshift';
